// extracted by mini-css-extract-plugin
export default {"invoiceRow":"_6S65tn4JSWjNiduCBcOi-","displayIcon":"_3DhTTcBVpMCGodL4IIosjz","NoDetailsHeld":"_3MXu9Inf3gWmEHv-KZoOOE","cardIcon":"-fC96qDJxYUkrYt0KbpO0"};